'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = require('../SvgIcon');

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavIntegrations = (_temp = _class = function (_SvgIcon) {
  _inherits(NavIntegrations, _SvgIcon);

  function NavIntegrations() {
    _classCallCheck(this, NavIntegrations);

    return _possibleConstructorReturn(this, (NavIntegrations.__proto__ || Object.getPrototypeOf(NavIntegrations)).apply(this, arguments));
  }

  _createClass(NavIntegrations, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M18.447 6c1.83 1.15 3.052 3.183 3.052 5.5 0 3.584-2.917 6.5-6.5 6.5H3.41l1.293-1.293c.39-.39.39-1.023 0-1.414-.39-.39-1.024-.39-1.414 0l-3 3c-.092.09-.165.202-.216.325-.1.244-.1.52 0 .764.05.123.124.234.217.326l3 3c.194.194.45.292.706.292.255 0 .51-.098.706-.293.39-.39.39-1.023 0-1.414L3.413 20H15c4.685 0 8.5-3.813 8.5-8.5 0-2.1-.778-4.016-2.045-5.5z' }),
          _react2['default'].createElement('path', { d: 'M29.922 3.618c-.05-.123-.124-.233-.217-.326l-3-3c-.39-.39-1.023-.39-1.413 0-.39.392-.39 1.024 0 1.415L26.585 3H15c-4.688 0-8.5 3.813-8.5 8.5 0 2.1.775 4.016 2.043 5.5h3.008c-1.83-1.15-3.05-3.183-3.05-5.5C8.5 7.916 11.414 5 15 5h11.584l-1.293 1.293c-.39.39-.39 1.023 0 1.414.195.195.45.293.707.293.255 0 .51-.098.706-.293l3-3c.092-.092.165-.202.216-.325.1-.244.1-.52 0-.764z' }),
          _react2['default'].createElement('circle', { cx: '14.999', cy: '11.5', r: '2.5' })
        );
      }

      return render;
    }()
  }]);

  return NavIntegrations;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 29.997427 23.000006'
}, _temp);
exports['default'] = NavIntegrations;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/SvgIcon/Nav/NavIntegrations.js
// module id = 1870
// module chunks = 32